import { Activity, activity } from '@attraqt/activity';
import * as abTest from '@attraqt/ab-test';
import { Search, search } from '@attraqt/search';
export var init = function (options) {
    if (options === void 0) { options = {}; }
    if (options.activity)
        activity.init(options.activity);
    if (options.search)
        search.init(options.search);
};
export { activity, Activity, abTest, search, Search };
//# sourceMappingURL=xo.js.map